/* @flow */
import ParamsLink from 'components/Links/ParamsLink';
import Td from 'components/UIKit/Table/Td';
import TrLink from '../TrLink';

const Row = ({
  children,
  description,
  IconComponent,
  router,
}: any): React.Element => {
  const newQuery = { did: children.node_id };
  const isActiveItem = children.node_id
    && (router.location.query.did === children.node_id);

  return (
    <TrLink
      isActiveItem={isActiveItem}
      linkId={children.node_id}
      router={router}
      >
      <Td customDataTestID="text-error-type">
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
          }}
          title={description}
          >
          <IconComponent style={{ marginRight: '.5rem' }} />
          {children.error}
        </div>
      </Td>

      <Td customDataTestID="text-severity" style={{ textTransform: 'capitalize' }}>
        {children.severity}
      </Td>

      <Td customDataTestID="text-description" style={{ textTransform: 'capitalize' }}>
        {children.message}
      </Td>

      <Td customDataTestID="text-node" >
        {children.node_id}
      </Td>

      <Td customDataTestID="text-related-nodes" >
        {children.related_nodes.map(node => (
          <span key={node}>
            {node}
          </span>
        ))}
      </Td>

      <Td customDataTestID="text-submitter-id" style={{ textTransform: 'capitalize' }}>
        {isActiveItem
          ? children.submitter_id
          : (
            <ParamsLink query={newQuery}>
              {children.submitter_id}
            </ParamsLink>
          )}
      </Td>
    </TrLink>
  );
};

export default Row;
